import React from 'react';

import { TestTypeMultiSelect } from '../../../picker/TestTypeMultiSelect';
import { useTestCaseFilterContext } from '../../TestCaseFilter';
import { useTestCasesInCycleList } from '../TestCaseInCycleListProvider';

export function TestCaseInCycleTestTypeFilter(): JSX.Element {
  const { testTypeFilter, setTestTypeFilter } = useTestCaseFilterContext();

  const { testCycle } = useTestCasesInCycleList();

  const testTypes = testCycle.testCases.map((testCase) => testCase.testType);

  return (
    <TestTypeMultiSelect
      testTypes={testTypes}
      isTestTypesLoaded={true}
      onChange={setTestTypeFilter}
      selectedTestTypes={testTypeFilter}
      showLabel={false}
      minWidth={250}
      spacing='compact'
    />
  );
}
